import { cartViewed } from '@repo/ui/src/services/analytics';
import { track } from '@repo/ui/src/services/analytics/utils';
import {
  basketLineInputToAnalytics,
  gcToAnalytics,
} from '@repo/ui/src/services/analytics/factories';
import { Basket, ProductProps } from '@repo/ui/src/types';
import { LineItem } from '@repo/ui/src/types/lineItem';

export const logCartViewed = (
  action: 'open cart' | 'close cart',
  basket: Basket,
  lineItems: Array<LineItem>,
  recommendations: Array<ProductProps>,
) => {
  track(cartViewed, {
    action,
    cart_id: basket.id,
    basket_token: basket.basketJWT,
    products: [
      ...lineItems.map((lineItem, i) => ({
        ...basketLineInputToAnalytics(lineItem),
        position: i + 1,
      })),
      ...basket.giftCards.map(gcToAnalytics),
    ],
    rec_strand: recommendations?.map((recommendation, i) => ({
      category: recommendation.mainCategory,
      description: recommendation.description,
      image_url: recommendation.mainImageUrl,
      name: recommendation.title,
      position: i + 1,
      price: recommendation.price,
      product_id: recommendation.product_id,
      quantity: recommendation.quantity,
      sku: recommendation.sku,
      url: window.location.href,
      variant: recommendation.color,
    })),
  });
};
